import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

const selectWebBookingApiAccess = (state: RootState) =>
  state.app.webBookingApiAccess;

export const selectWebBookingApiKeyExists = createSelector(
  selectWebBookingApiAccess,
  (s) => s.hasKey
);

export const selectWebBookingApiKeyValue = createSelector(
  selectWebBookingApiAccess,
  (s) => s.keyValue
);

export const selectGenerateKeyRequestInProgress = createSelector(
  selectWebBookingApiAccess,
  (s) => s.generateRequestInProgress
);
